module.exports = __webpack_public_path__ + "static/media/lunch1.123861cb.png";